module.exports = __webpack_public_path__ + "img/H3M6_new.7871c401.jpg";